<div class="customers-details-container">
  <!-- Loading Spinner -->
  @if (loading) {
    <div class="loading-container">
      <mat-spinner></mat-spinner>
      <p>Adatok betöltése...</p>
    </div>
  }

  <!-- Error State -->
  @if (error && !loading) {
    <div class="error-container">
      <mat-card class="error-card">
        <mat-card-content>
          <div class="error-content">
            <mat-icon color="warn">error</mat-icon>
            <p>{{ error }}</p>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  }


  <!-- Company Details -->
  @if ((company || individualCustomer) && !loading && !error) {
    <div class="company-content">
      <div class="info-grid">
        <!-- Céginformációk kártya - csak akkor jelenik meg, ha van company adat -->
        @if (company) {
          <mat-card class="info-card">
            <mat-card-header class="company-info-header">
              <mat-card-title>Céginformációk</mat-card-title>
              <div class="header-actions">
                <!-- Szerkesztés gomb -->
                <app-circle-icon-button
                  icon="edit"
                  [backgroundColor]="'#e3f2fd'"
                  [hoverBackgroundColor]="'#bbdefb'"
                  [color]="'#1976d2'"
                  [title]="'Adatok szerkesztése'"
                  (click)="onEditCompany()">
                </app-circle-icon-button>
              </div>
            </mat-card-header>
            <mat-card-content>
              <div class="info-row">
                <label>Azonosító:</label>
                <span class="value">{{ company.id }}</span>
              </div>
              <div class="info-row">
                <label>Cégnév:</label>
                <span class="value">{{ company.companyname || '-' }}</span>
              </div>
              <div class="info-row">
                <label>Cégjegyzékszám:</label>
                <span class="value">{{ company.registrationNumber || '-' }}</span>
              </div>
              <div class="info-row">
                <label>Adószám:</label>
                <span class="value">{{ company.taxNumber || '-' }}</span>
              </div>
              <div class="info-row">
                <label>Cím:</label>
                <span class="value">{{ company.address || '-' }}</span>
              </div>
              <div class="info-row">
                <label>Megye:</label>
                <span class="value">{{ company.county || '-' }}</span>
              </div>
              <div class="info-row">
                <label>Főtevékenység:</label>
                <span class="value">{{ company.mainActivity || '-' }}</span>
              </div>
              <div class="info-row">
                <label>Nettó árbevétel:</label>
                <span class="value">{{ company.netRevenue ? formatCurrency(company.netRevenue, 'HUF') : '-' }}</span>
              </div>
              <div class="info-row">
                <label>Alkalmazottak száma:</label>
                <span class="value">{{ company.employeeCount || '-' }}</span>
              </div>
              <div class="info-row">
                <label>CC Státusz:</label>
                <span class="value">{{ company.ccStatus || '-' }}</span>
              </div>
              <div class="info-row">
                <label>KUM Státusz:</label>
                <span class="value">{{ company.kumStatus || '-' }}</span>
              </div>
              <div class="info-row">
                <label>Meglévő ügyfél:</label>
                <span class="value">{{ company.existingCustomer ? 'Igen' : 'Nem' }}</span>
              </div>
              <div class="info-row">
                <label>Létrehozva:</label>
                <span class="value">{{ company.createdat ? formatDate(company.createdat) : '-' }}</span>
              </div>
            </mat-card-content>
            <mat-card-header class="contacts-header">
              <mat-card-title>Cég elérhetőségek</mat-card-title>
            </mat-card-header>
            <mat-card-content class="contacts-content">
              <!-- Email címek -->
              <div class="contact-section">
                <div class="contact-section-header">
                  <h4><mat-icon class="section-icon">email</mat-icon>Email címek</h4>
                  <app-circle-icon-button
                    icon="add"
                    [backgroundColor]="'#e8f5e8'"
                    [hoverBackgroundColor]="'#c8e6c9'"
                    [color]="'#2e7d32'"
                    [matMenuTriggerFor]="smallEmailInputMenuComponent.menu"
                    [title]="'Új email cím hozzáadása'"
                    #addEmailMenuTrigger="matMenuTrigger">
                  </app-circle-icon-button>
                </div>
                @if (company.emails && company.emails.length > 0) {
                  <div class="chips-container">
                    @for (email of company.emails; track email) {
                      <app-call-center-chip
                [config]="{
                  text: email.email,
                  type: 'email',
                  validStatus: email.validstatus
                }"
                        [matMenuTriggerFor]="emailMenu.menu"
                        (click)="onChipClick(email.email, emailMenuTrigger, 'email', 'company')"
                        #emailMenuTrigger="matMenuTrigger">
                      </app-call-center-chip>
                    }
                  </div>
                }
                @if (!company.emails || company.emails.length === 0) {
                  <div class="no-items-message">
                    <p>Nincsenek email címek regisztrálva.</p>
                  </div>
                }
              </div>
              <!-- Telefonszámok -->
              <div class="contact-section">
                <div class="contact-section-header">
                  <h4><mat-icon class="section-icon">phone</mat-icon>Telefonszámok</h4>
                  <app-circle-icon-button
                    icon="add"
                    [backgroundColor]="'#e3f2fd'"
                    [hoverBackgroundColor]="'#bbdefb'"
                    [color]="'#1976d2'"
                    [matMenuTriggerFor]="smallPhoneInputMenuComponent.menu"
                    [title]="'Új telefonszám hozzáadása'"
                    #addPhoneMenuTrigger="matMenuTrigger">
                  </app-circle-icon-button>
                </div>
                @if (company.phones && company.phones.length > 0) {
                  <div class="chips-container">
                    @for (phone of company.phones; track phone) {
                      <app-call-center-chip
                [config]="{
                  text: phone.phone,
                  type: 'phone',
                  validStatus: phone.validstatus
                }"
                        [matMenuTriggerFor]="phoneMenu.menu"
                        (click)="onChipClick(phone.phone, phoneMenuTrigger, 'phone', 'company')"
                        #phoneMenuTrigger="matMenuTrigger">
                      </app-call-center-chip>
                    }
                  </div>
                }
                @if (!company.phones || company.phones.length === 0) {
                  <div class="no-items-message">
                    <p>Nincsenek telefonszámok regisztrálva.</p>
                  </div>
                }
              </div>
            </mat-card-content>
          </mat-card>
        }
        <!-- Ügyfelek card -->
        <mat-card class="info-card">
          <mat-card-header>
            <mat-card-title>Ügyfelek</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <!-- Ügyfelek megjelenítése (céges vagy magánszemély) -->
            @if ((company && company.relatedCustomers && company.relatedCustomers.length > 0) || individualCustomer) {
              <div>
                <mat-accordion multi="true" class="customers-accordion">
                  @for (customer of (company?.relatedCustomers || []).concat(individualCustomer ? [individualCustomer] : []); track customer; let i = $index) {
                    <mat-expansion-panel
                      class="customer-expansion-panel"
                      [(expanded)]="customer.expanded">
                      <mat-expansion-panel-header class="customer-header-with-edit">
                        <mat-panel-title class="customer-name-title">
                          {{ customer.fullName }}
                          <div class="edit-button-container">
                            <app-circle-icon-button
                              icon="edit"
                              [backgroundColor]="'#fff3e0'"
                              [hoverBackgroundColor]="'#ffe0b2'"
                              [color]="'#f57c00'"
                              [title]="'Ügyfél adatok szerkesztése'"
                              (click)="onEditCustomer(customer); $event.stopPropagation()">
                            </app-circle-icon-button>
                          </div>
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <div class="customer-details">
                        <div class="info-row">
                          <label>Ügyfél ID:</label>
                          <span class="value">{{ customer.id }}</span>
                        </div>
                        <div class="info-row">
                          <label>Cím:</label>
                          <span class="value">{{ customer.address || '-' }}</span>
                        </div>
                        <div class="info-row">
                          <label>Születési dátum:</label>
                          <span class="value">{{ customer.birthDate ? formatDate(customer.birthDate) : '-' }}</span>
                        </div>
                        <div class="info-row">
                          <label>Születési hely:</label>
                          <span class="value">{{ customer.birthPlace || '-' }}</span>
                        </div>
                        <div class="info-row">
                          <label>Anyja neve:</label>
                          <span class="value">{{ customer.motherName || '-' }}</span>
                        </div>
                        <div class="info-row">
                          <label>Adószám:</label>
                          <span class="value">{{ customer.taxNumber || '-' }}</span>
                        </div>
                        <div class="info-row">
                          <label>Létrehozva:</label>
                          <span class="value">{{ formatDate(customer.createdAt) }}</span>
                        </div>
                        <!-- <div class="info-row">
                        <label>Érvényesség státusza:</label>
                        <span class="value">
                          <mat-chip [color]="customer.validStatus === true ? 'primary' : customer.validStatus === false ? 'warn' : 'accent'" class="status-chip">
                            {{ customer.validStatus === true ? 'Érvényes' : customer.validStatus === false ? 'Érvénytelen' : 'Nincs megadva' }}
                          </mat-chip>
                        </span>
                      </div> -->
                      <div class="info-row">
                        <label>Meglévő ügyfél:</label>
                        <span class="value">{{ customer.existingCustomer ? 'Igen' : 'Nem' }}</span>
                      </div>
                      @if (customer.relationshipNotes) {
                        <div class="info-row">
                          <label>Kapcsolat megjegyzése:</label>
                          <span class="value">{{ customer.relationshipNotes }}</span>
                        </div>
                      }
                    </div>
                    <!-- Ügyfél elérhetőségek -->
                    <div class="contact-section">
                      <div class="contact-section-header">
                        <h4>Ügyfél elérhetőségek</h4>
                        <div class="contact-actions">
                          <app-circle-icon-button
                            icon="add_call"
                            [backgroundColor]="'#e3f2fd'"
                            [hoverBackgroundColor]="'#bbdefb'"
                            [color]="'#1976d2'"
                            [title]="'Új telefonszám hozzáadása ügyfélhez'"
                            [matMenuTriggerFor]="customerPhoneInputMenuComponent.menu"
                            #addCustomerPhoneMenuTrigger="matMenuTrigger"
                            (click)="setSelectedCustomer(customer)">
                          </app-circle-icon-button>
                          <app-circle-icon-button
                            icon="email"
                            [backgroundColor]="'#e8f5e8'"
                            [hoverBackgroundColor]="'#c8e6c9'"
                            [color]="'#2e7d32'"
                            [title]="'Új email cím hozzáadása ügyfélhez'"
                            [matMenuTriggerFor]="customerEmailInputMenuComponent.menu"
                            #addCustomerEmailMenuTrigger="matMenuTrigger"
                            (click)="setSelectedCustomer(customer)">
                          </app-circle-icon-button>
                        </div>
                      </div>
                      <!-- Email címek -->
                      @if (customer.emails && customer.emails.length > 0) {
                        <div class="contact-group">
                          <label class="contact-label">Email címek:</label>
                          <div class="contact-chips">
                            @for (email of customer.emails; track email) {
                              <app-call-center-chip
                      [config]="{
                        text: email.email,
                        type: 'email',
                        validStatus: email.validstatus
                      }"
                                [matMenuTriggerFor]="customerEmailMenu.menu"
                                (click)="onChipClick(email.email, customerEmailMenuTrigger, 'email', 'customer', customer.id)"
                                #customerEmailMenuTrigger="matMenuTrigger">
                              </app-call-center-chip>
                            }
                          </div>
                        </div>
                      }
                      <!-- Telefonszámok -->
                      @if (customer.phones && customer.phones.length > 0) {
                        <div class="contact-group">
                          <label class="contact-label">Telefonszámok:</label>
                          <div class="contact-chips">
                            @for (phone of customer.phones; track phone) {
                              <app-call-center-chip
                      [config]="{
                        text: phone.phone,
                        type: 'phone',
                        validStatus: phone.validstatus
                      }"
                                [matMenuTriggerFor]="customerPhoneMenu.menu"
                                (click)="onChipClick(phone.phone, customerPhoneMenuTrigger, 'phone', 'customer', customer.id)"
                                #customerPhoneMenuTrigger="matMenuTrigger">
                              </app-call-center-chip>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  </mat-expansion-panel>
                }
              </mat-accordion>
            </div>
          }
          <!-- Ha nincs sem céges, sem magánszemély ügyfél -->
          @if ((!company || !company.relatedCustomers || company.relatedCustomers.length === 0) && !individualCustomer) {
            <div class="no-customers">
              <p>Nincsenek ügyfelek regisztrálva.</p>
            </div>
          }
          <ng-template #noCustomers>
            <div class="no-customers">
              <p>Nincsenek kapcsolódó ügyfelek a céghez.</p>
            </div>
          </ng-template>
        </mat-card-content>
      </mat-card>
    </div>
    <!-- Szerződések Section -->
    @if (company || individualCustomer) {
      <div class="contracts-section">
        <mat-card class="contracts-card">
          <mat-card-header>
            <mat-card-title>Kapcsolódó Szerződések</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <!-- Loading spinner for contracts -->
            @if (contractsLoading) {
              <div class="contracts-loading">
                <mat-spinner diameter="40"></mat-spinner>
                <p>Szerződések betöltése...</p>
              </div>
            }
            <!-- Error message for contracts -->
            @if (contractsError && !contractsLoading) {
              <div class="contracts-error">
                <mat-icon color="warn">error</mat-icon>
                <p>{{ contractsError }}</p>
              </div>
            }
            <!-- Contracts table -->
            @if (!contractsLoading && !contractsError) {
              <div>
                <app-contracts-list-table
                  [data]="contracts"
                  [showHeader]="false">
                </app-contracts-list-table>
              </div>
            }
          </mat-card-content>
        </mat-card>
      </div>
    }
    <!-- Interakciók (Logok) Section -->
    @if (company || individualCustomer) {
      <div class="interactions-section">
        <mat-card class="interactions-card">
          <mat-card-header>
            <mat-card-title>Kapcsolódó Logok</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <!-- Interactions table (with built-in loading/error states) -->
            <app-extended-logs-table
              [paginatedLogs]="interactions"
              [loading]="interactionsLoading"
              [error]="interactionsError"
              [totalLogs]="interactions.length">
            </app-extended-logs-table>
          </mat-card-content>
        </mat-card>
      </div>
    }
  </div>
}
</div>

<!-- Small Input Menu for Email -->
<app-small-input-menu
  #smallEmailInputMenuComponent
  inputType="email"
  [label]="'Új email cím'"
  [placeholder]="'Email cím megadása...'"
  [menuTrigger]="addEmailMenuTrigger"
  (emailAdded)="onEmailAdded($event)"
  class="email-input-menu">
</app-small-input-menu>

<!-- Small Input Menu for Phone (Company) -->
<app-small-input-menu
  #smallPhoneInputMenuComponent
  inputType="phone"
  [label]="'Új telefonszám'"
  [placeholder]="'+36 XX XXX XXXX'"
  [menuTrigger]="addPhoneMenuTrigger"
  (phoneAdded)="onPhoneAdded($event)"
  class="phone-input-menu">
</app-small-input-menu>

<!-- Small Input Menu for Customer Phone -->
<app-small-input-menu
  #customerPhoneInputMenuComponent
  inputType="phone"
  [label]="'Új telefonszám ügyfélhez'"
  [placeholder]="'+36 XX XXX XXXX'"
  [menuTrigger]="addCustomerPhoneMenuTrigger"
  (phoneAdded)="onCustomerPhoneAdded($event)"
  class="customer-phone-input-menu">
</app-small-input-menu>

<!-- Small Input Menu for Customer Email -->
<app-small-input-menu
  #customerEmailInputMenuComponent
  inputType="email"
  [label]="'Új email cím ügyfélhez'"
  [placeholder]="'Email cím megadása...'"
  [menuTrigger]="addCustomerEmailMenuTrigger"
  (emailAdded)="onCustomerEmailAdded($event)"
  class="customer-email-input-menu">
</app-small-input-menu>

<!-- Contact edit input menu is now at line 589-600 as editInputMenuForChip -->

<!-- Icon Menus for chip actions -->
<app-small-icon-menu
  #emailMenu
  menuId="emailMenu"
  [actions]="customMenuActions"
  (actionClicked)="onIconMenuAction($event)">
</app-small-icon-menu>

<app-small-icon-menu
  #phoneMenu
  menuId="phoneMenu"
  [actions]="customMenuActions"
  (actionClicked)="onIconMenuAction($event)">
</app-small-icon-menu>

<app-small-icon-menu
  #customerEmailMenu
  menuId="customerEmailMenu"
  [actions]="customMenuActions"
  (actionClicked)="onIconMenuAction($event)">
</app-small-icon-menu>

<app-small-icon-menu
  #customerPhoneMenu
  menuId="customerPhoneMenu"
  [actions]="customMenuActions"
  (actionClicked)="onIconMenuAction($event)">
</app-small-icon-menu>

<!-- Edit Input Menu (will be triggered programmatically) -->
<app-small-input-menu
  #editInputMenuForChip
  [inputType]="selectedChipType"
  [label]="selectedChipType === 'email' ? 'Email cím szerkesztése' : 'Telefonszám szerkesztése'"
  [placeholder]="selectedChipType === 'email' ? 'Email cím módosítása...' : 'Telefonszám módosítása...'"
  [inputValue]="editingContactValue"
  [menuTrigger]="editTrigger"
  (valueAdded)="onContactEditSaved($event)"
  (cancelled)="onContactEditCancelled()"
  class="edit-contact-chip-menu">
</app-small-input-menu>

<!-- Hidden edit trigger that will be positioned dynamically -->
@if (editInputMenuForChip?.menu) {
  <span
    [matMenuTriggerFor]="editInputMenuForChip.menu"
    #editTrigger="matMenuTrigger"
    class="hidden-edit-trigger"
    [style.position]="'fixed'"
    [style.left.px]="editTriggerX"
    [style.top.px]="editTriggerY"
    [style.visibility]="'hidden'"
    [style.pointerEvents]="'none'"
    [style.width.px]="1"
    [style.height.px]="1">
  </span>
}

